import * as React from 'react';
import type { SVGProps } from 'react';

const IconCheckMarkRounded = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 34" {...props}>
    <rect
      x="1.003"
      y="1.251"
      width="31.997"
      height="31.997"
      rx="15.998"
      fill="#fff"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.666 12.995 13.708 24.591l-6.374-5.704 1.334-1.49 5.04 4.51 11.625-10.402 1.333 1.49Z"
      fill="currentColor"
    />
  </svg>
);
export default IconCheckMarkRounded;
